/* No guessed measurements: surface only an existing product size table. */
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.sizeHelpReady) return;
      section.dataset.sizeHelpReady = 'true';
      const details = section.querySelector('[data-product-details]');
      const tables = Array.from(section.querySelectorAll('.product-description table'));
      const table = tables.find((item) => /breite|länge|laenge|width|length|brust|chest|umfang|diameter|durchmesser/i.test(item.textContent));
      if (!details || !table) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'nsc-size-table';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Size guide – scroll horizontally');
      table.before(wrapper);
      wrapper.appendChild(table);
      section.querySelectorAll('[data-size-guide-link]').forEach((button) => {
        button.hidden = false;
        button.addEventListener('click', () => {
          details.open = true;
          wrapper.focus({ preventScroll: true });
          wrapper.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
